/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, memo } from "react"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import useChatNotification from "../../../hooks/useChatNotification"
import {
  chatActionsSelector,
  chatIsReadAtom,
  newRepliesAtom,
  prevNewReplyAtom
} from "../../../recoil/atoms/chats"
import layoutStates from "../../../recoil/atoms/layout"
import { localUserStaticPropsAtom } from "../../../recoil/atoms/users"
import { respondToVisibility } from "../../../util/respondToVisibility"
/* import { brandingSelector } from "../../../recoil/atoms/room"
import { isRGBAcolor, removeOpacity } from "../../../util" */

type HandleNewReplyMessageProps = {
  getParentIdDirection: (parentChatId: any) => "UP" | "DOWN"
  checkWhoComeFirst: (
    parentId1: string | number,
    parentId2: string | number
  ) => string | number
  handleScrollToBottomChat: () => Promise<() => void>
  scrollElementId: string
  isMobile: boolean
}

const HandleNewReplyMessage = ({
  getParentIdDirection,
  checkWhoComeFirst,
  handleScrollToBottomChat,
  scrollElementId,
  isMobile
}: HandleNewReplyMessageProps) => {
  /* const roomStyles = useRecoilValue(brandingSelector) */
  const localUserProps = useRecoilValue(localUserStaticPropsAtom)
  const newReplies = useRecoilValue(newRepliesAtom)
  const [prevNewReply, setPrevNewReply] = useRecoilState(prevNewReplyAtom)
  const prevAllReplyId = useRef(prevNewReply)

  const setChatIsRead = useSetRecoilState(chatIsReadAtom)

  const {
    bottomMostUnreadRef,
    setBottomMostMessage,
    setTopMostMessage,
    topMostUnreadRef
  } = useChatNotification()

  const chatActions = useRecoilValue(chatActionsSelector)
  const [isChatTab] = useRecoilState<boolean>(layoutStates.isChatTab)

  const handleReplyIsRead = React.useCallback(
    newReply => {
      const messagesContainer = document.getElementById(scrollElementId)
      const replyContainer = document.getElementById(`reply-${newReply.id}`)
      const messagesContainerBottomBorder =
        messagesContainer?.getBoundingClientRect()?.bottom
      const messagesContainerTopBorder =
        messagesContainer?.getBoundingClientRect()?.top
      const replyContainerBottomBorder =
        replyContainer?.getBoundingClientRect()?.bottom
      const replyContainerTopBorder =
        replyContainer?.getBoundingClientRect()?.top
      // setChatIsRead(true)
      const bottomZone =
        messagesContainer?.scrollTop >=
        messagesContainer?.scrollHeight -
          messagesContainer?.clientHeight -
          (isMobile ? 100 : 400)

      if (replyContainer) {
        if (
          messagesContainerBottomBorder > replyContainerBottomBorder &&
          replyContainerTopBorder > messagesContainerTopBorder
        ) {
          // 1. Element Is present and is visible -> Do nothing
        } else {
          // 2. Element Is present but not visible -> then set top most and bottom most
          setChatIsRead(false)

          if (messagesContainerBottomBorder < replyContainerBottomBorder) {
            // Element is present down
            if (bottomZone) {
              // setChatIsRead(true)
              handleScrollToBottomChat()
            } else {
              // Top check if current message is bottom most
              if (!bottomMostUnreadRef.current?.parentId) {
                // setChatIsRead(false)
                setBottomMostMessage({
                  id: newReply.id,
                  parentId: newReply.parentId
                })
              } else {
                const topParentId = checkWhoComeFirst(
                  bottomMostUnreadRef.current?.parentId,
                  newReply.parentId
                )
                if (topParentId === bottomMostUnreadRef.current?.parentId) {
                  setBottomMostMessage({
                    id: newReply.id,
                    parentId: newReply.parentId
                  })
                }
              }
            }
          } else if (
            messagesContainerTopBorder > replyContainerBottomBorder ||
            messagesContainerTopBorder > replyContainerTopBorder
          ) {
            // Element is present Up
            // check if current message is topmost
            const topParentId = checkWhoComeFirst(
              topMostUnreadRef.current?.parentId,
              newReply.parentId
            )
            if (topParentId === newReply.parentId) {
              setTopMostMessage({
                id: newReply.id,
                parentId: newReply.parentId
              })
            }
          }
        }
      } else {
        // Not present
        const direction = getParentIdDirection(newReply.parentId)
        if (direction === "UP") {
          const topParentId = checkWhoComeFirst(
            topMostUnreadRef.current?.parentId,
            newReply.parentId
          )
          if (topParentId === newReply.parentId) {
            setTopMostMessage({ id: newReply.id, parentId: newReply.parentId })
          }
        } else {
          if (!bottomMostUnreadRef.current?.parentId) {
            setBottomMostMessage({
              id: newReply.id,
              parentId: newReply.parentId
            })
          } else {
            const topParentId = checkWhoComeFirst(
              bottomMostUnreadRef.current?.parentId,
              newReply.parentId
            )
            if (topParentId === bottomMostUnreadRef.current?.parentId) {
              setBottomMostMessage({
                id: newReply.id,
                parentId: newReply.parentId
              })
            }
          }
        }
      }

      respondToVisibility(`reply-${newReply?.id}`, () => {
        const target = document.getElementById(`notification-${newReply?.id}`)
        /* const targetReplyContainer = document.getElementById(
          `reply-bg-container-${newReply?.id}`
        ) */
        target.style.display = "flex"
        /*  if (isRGBAcolor(roomStyles.servicePanelElementBackground)) {
          targetReplyContainer.style.background = removeOpacity(
            roomStyles.servicePanelElementBackground
          )
        } */
        setTimeout(() => {
          /* if (isRGBAcolor(roomStyles.servicePanelElementBackground)) {
            targetReplyContainer.style.background =
              roomStyles.servicePanelElementBackground
          } */
          target.style.display = "none"
        }, 3500)
      })
    },
    [handleScrollToBottomChat]
  )

  React.useEffect(() => {
    prevAllReplyId.current = prevNewReply
  }, [prevNewReply])

  React.useEffect(() => {
    const messagesContainer = document.getElementById(scrollElementId)

    if (!isChatTab) {
      if (
        newReplies &&
        newReplies?.length !== 0 &&
        prevAllReplyId.current.id !== newReplies[0].id
      ) {
        newReplies.forEach(async reply => {
          const parentNewReply = await chatActions.getChatDataById(
            reply.parentId
          )
          if (parentNewReply?.participants.includes(localUserProps.id)) {
            setChatIsRead(false)
          }
        })
      }
      return
    }

    if (
      newReplies &&
      newReplies?.length !== 0 &&
      prevAllReplyId.current.id !== newReplies[0].id
    ) {
      setPrevNewReply(newReplies[0])
      newReplies.forEach(async reply => {
        const parentNewReply = await chatActions.getChatDataById(reply.parentId)

        const authorReplyId = parentNewReply?.replyChats?.filter(
          item => item.id === reply?.id
        )?.[0]?.author?.id

        const bottomZone =
          messagesContainer?.scrollTop >=
          messagesContainer?.scrollHeight -
            messagesContainer?.clientHeight -
            (isMobile ? 100 : 400)

        if (bottomZone) {
          handleScrollToBottomChat()
        }

        if (authorReplyId === localUserProps.id) {
          // local user message
          const replyContainer = document.getElementById(`reply-${reply.id}`)
          const replyContainerBottomBorder =
            replyContainer?.getBoundingClientRect()?.bottom
          const messagesContainerBottomBorder =
            messagesContainer?.getBoundingClientRect()?.bottom
          if (messagesContainerBottomBorder < replyContainerBottomBorder) {
            handleScrollToBottomChat()
          }
          return
        }

        if (parentNewReply?.participants?.includes(localUserProps.id)) {
          handleReplyIsRead(reply)
          if (!isChatTab) {
            setChatIsRead(false)
          }
        }
      })
    }
  }, [newReplies, handleReplyIsRead, isChatTab])

  return null
}

export default memo(HandleNewReplyMessage)
